import type { ErrorReport } from '../../types';
import { CodeBlock } from '../code-block';

type P = {
  stacks: ErrorReport['errorSummary']['stacks'];
};

export const useGetStackItems = ({ stacks = [] }: P) =>
  stacks.map(({ name, stack }, index) => ({
    children: <CodeBlock value={stack} />,
    key: `stack-${index}`,
    label: `${name} stack`,
  }));
